import React, { useState } from "react";
import styled from "styled-components";
import { theme } from "../../styles/theme";
import { Button } from "../ui/Button";
import { Input, ErrorMessage, Label } from "../ui/Input";
import { createSeed } from "../../services/api";

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.md};
`;

function SubmitModal({ onSuccess }) {
  const [url, setUrl] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (!url.trim()) {
      setError("Please paste a TikTok URL");
      return;
    }

    setLoading(true);
    setUrl("");
    if (onSuccess) {
      onSuccess();
    }
    createSeed(url.trim())
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Failed to add seed", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div>
        <Label htmlFor="seed-url">TikTok URL</Label>
        <Input
          id="seed-url"
          type="text"
          placeholder="https://www.tiktok.com/..."
          value={url}
          onChange={(event) => setUrl(event.target.value)}
          disabled={loading}
          autoFocus
          error={Boolean(error)}
        />
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </div>

      <Button type="submit" disabled={loading} fullWidth>
        {loading ? "Submitting..." : "Add seed"}
      </Button>
    </Form>
  );
}

export default SubmitModal;
